module.exports = __webpack_public_path__ + "static/media/inbox.c75831cc.svg";